import { render, staticRenderFns } from "./selected-list.vue?vue&type=template&id=0a965924&"
import script from "./selected-list.vue?vue&type=script&lang=js&"
export * from "./selected-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports